import { RouterProvider } from "react-router-dom";
import { router } from "@/config/router";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/hooks/useTheme";
import { useWebPush } from "@/hooks/useWebPush";

export default function App() {
  useTheme();
  // Activación de push del navegador tras el login. Por defecto ON: cuando hay
  // sesión y tenant activo se intenta habilitar (el navegador exige permiso
  // explícito; si se deniega, degrada en silencio). No bloquea el render ni
  // pide permiso en bucle (el hook intenta una sola vez por montaje).
  const { status, currentTenantId } = useAuth();
  const sessionReady = status === "authenticated" && Boolean(currentTenantId);
  useWebPush({ autoEnable: sessionReady });

  return <RouterProvider router={router} />;
}
